import { useContext, useEffect, useState } from "react";

export const useShippingSearchFooter = (props) => {
    return {};
};
